import { api } from "../services/Api";

export function useImport() {
  const baseUrl = "/sellers";

  const postImportCsv = (file: File, id?: string) => {
    let formData = new FormData();
    formData.append("file", file);
    return api.post(`${baseUrl}/${id}/import/subject`, formData);
  }

  return {
    postImportCsv,
  };
}
